import TwitterIconDark from 'assets/images/icons/dark - twitter.svg?react';
import TwitterIconSimpleFiligree from 'assets/images/icons/simple filigree - twitter.svg?react';
import TwitterIconSpringVibes from 'assets/images/icons/spring - twitter.svg?react';
import TwitterIconVickyBaumannBoho from 'assets/images/icons/vicky boho - twitter.svg?react';
import TwitterIconVickyBaumannFineart from 'assets/images/icons/vicky fineart - twitter.svg?react';
import { IIconProps } from 'types/icons';
import { BaseIcon } from './BaseIcon';
import { SetIcon } from './SetIcon';
import { useTemplateVariant } from 'hooks/useTemplateVariant';

const LegacyTwitterIcon = (props: IIconProps) =>
  useTemplateVariant({
    classic: () => <BaseIcon icon={TwitterIconSimpleFiligree} {...props} />,
    dark: () => <BaseIcon icon={TwitterIconDark} {...props} />,
    simpleFiligree: () => <BaseIcon icon={TwitterIconSimpleFiligree} {...props} />,
    springVibes: () => <BaseIcon icon={TwitterIconSpringVibes} {...props} />,
    vickyBaumannBoho: () => <BaseIcon icon={TwitterIconVickyBaumannBoho} {...props} />,
    vickyBaumannFineart: () => <BaseIcon icon={TwitterIconVickyBaumannFineart} {...props} />,
    breeze: () => <BaseIcon icon={TwitterIconSimpleFiligree} {...props} />,
    capri: () => <BaseIcon icon={TwitterIconSimpleFiligree} {...props} />,
    rose: () => <BaseIcon icon={TwitterIconSimpleFiligree} {...props} />,
    calm: () => <BaseIcon icon={TwitterIconSimpleFiligree} {...props} />
  })();

export const TwitterIcon = (props: IIconProps) => (
  <SetIcon slug="x-twitter" fallback={LegacyTwitterIcon} {...props} />
);
